export const BENEFITS_ONBOARDING_TOUR_PANEL_ARROW_LEFT_INSET = 24;
export function computeTourArrowTargetX(params) {
    const { mode, holeLeft, holeWidth } = params;
    if (holeWidth <= 0) {
        return holeLeft;
    }
    switch (mode) {
        case 'hole-start':
            return holeLeft + holeWidth * 0.1;
        case 'hole-end':
            return holeLeft + holeWidth * 0.88;
        case 'hole-center':
        default:
            return holeLeft + holeWidth / 2;
    }
}
